import { css } from "styled-components";
export const textSizes = {
  tiny: css(["font-size:12px;"]),
  small: css(["font-size:13px;"]),
  default: css(["font-size:14px;"]),
  medium: css(["font-size:16px;font-weight:700;"]),
  large: css(["font-size:18px;font-weight:700;"])
};
export default function textSize({
  textSize
}) {
  return textSizes[textSize] || textSizes.default;
}
//# sourceMappingURL=textSize.js.map